import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { withFormik, Field } from 'formik';
import * as yup from 'yup';

import { Form } from 'reactstrap';
import FieldInputComponent from 'components/FieldInputComponent';
import ButtonCustom from 'components/ButtonCustom';
import { toggleForgotPasswordModal } from 'store/modules/modals';

import { MIN_PASSWORD_LENGTH } from 'helpers/constants';

const SignInSchema = yup.object().shape({
  email: yup
    .string()
    .email('Invalid email address')
    .required("Email can't be empty"),
  password: yup
    .string()
    .min(
      MIN_PASSWORD_LENGTH,
      `Password has to be longer than ${MIN_PASSWORD_LENGTH} characters!`,
    )
    .required("Password can't be empty"),
});

const UserFormSignIn = ({
  isSubmitting,
  handleSubmit,
  isValid,
  touched,
  errors,
  toggleForgotPasswordModal,
}) => {
  return (
    <Form className="order-form">
      <div className="h2-title big center">Sign In</div>
      <div className="text text-300 center">Enter your information below</div>
      <div className="separator-line" />
      <Field
        name="email"
        component={FieldInputComponent}
        error={touched.email && errors.email}
        type="text"
        label="Email"
        classInput="form-input input-border"
      />
      <Field
        name="password"
        component={FieldInputComponent}
        error={touched.password && errors.password}
        type="password"
        label="Password"
        link="Forgot password"
        linkRoutes="#"
        linkOnClick={toggleForgotPasswordModal}
        classInput="form-input input-border"
      />
      <div className="order-form__btn">
        <ButtonCustom
          className="btn btn-blue big"
          type="submit"
          disabled={!isValid || isSubmitting}
          onClick={handleSubmit}>
          {isSubmitting ? 'Loading' : ' Sign in'}
        </ButtonCustom>
      </div>
    </Form>
  );
};

const mapDispatchToProps = {
  toggleForgotPasswordModal,
};

export default compose(
  connect(
    null,
    mapDispatchToProps,
  ),

  withFormik({
    mapPropsToValues: () => ({
      email: '',
      password: '',
    }),
    isInitialValid: false,
    validationSchema: SignInSchema,

    handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
      await props.handleSubmit(values, setSubmitting, setErrors);
    },
  }),
)(UserFormSignIn);



// WEBPACK FOOTER //
// ./src/scenes/SignIn/UserFormSignIn.js